/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { GenericCard } from '../../../../../ui-components/Card/GenericCard';
import { VpcCard } from './VpcCard';
import { CloudData, VpcData } from '../../BgpVisibilityData';

interface CloudContainerProps {
  data: CloudData;
  onCardClick?: (data: CloudData) => void;
  onVpcClick?: (vpcData: VpcData) => void;
  onRouteTableClick?: (routeTableData: any, vpcId: string) => void;
  isOutbound?: boolean;
}

export const CloudContainer: React.FC<CloudContainerProps> = ({ 
  data, 
  onCardClick, 
  onVpcClick, 
  onRouteTableClick, 
  isOutbound = false 
}) => {
  const { label, vpcs, allData, headerColor } = data;
  
  const headerContent = (
    <div className="flex items-center space-x-2">
      <h2 className="text-lg font-semibold text-semantic-text-primary">{label}</h2>
    </div>
  );

  const bodyContent = (
    <div className="space-y-4">
      {vpcs.map((vpc: any, index: number) => {
        const routeTables = allData
          .filter((entry: any) => entry.vpc === vpc)
          .reduce((acc: any, entry: any) => {
            const key = isOutbound ? (entry.subnet_id || entry.route_table_id) : entry.route_table_id;
            const existing = acc.find((rt: any) => rt.route_table_id === key);
            if (existing) {
              existing.prefixes.push(entry);
            } else {
              acc.push({
                route_table_id: key,
                prefixes: [entry]
              });
            }
            return acc;
          }, []);
        
        return (
          <VpcCard 
            key={index} 
            data={{ vpcId: vpc, routeTables }} 
            onCardClick={onVpcClick}
            onRouteTableClick={onRouteTableClick}
            isOutbound={isOutbound}
          />
        );
      })}
    </div>
  );

  return (
    <div 
      onClick={() => onCardClick?.(data)}
      className="cursor-pointer"
      style={{ pointerEvents: 'auto' }}
    >
      <GenericCard
        variant="primary"
        shadow="sm"
        isCollapsible={false}
        headerContent={headerContent}
        bodyContent={bodyContent}
        headerColor={headerColor}
        className="min-w-[400px] "
        style={{ zIndex: 1 }}
      />
    </div>
  );
};

